<template>
  <span>
    <v-dialog max-width="500px" persistent v-model="dialog">
      <template #activator="{on}">
        <div slot="activator" v-on="on">
          <slot>
            <v-btn icon>
              <v-icon>edit</v-icon>
            </v-btn>
          </slot>
        </div>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t("deputyAuth.form.title") }}</span>
        </v-card-title>
        <v-card-text>
          <v-form lazy-validation ref="form" v-model="formValid">
            <v-autocomplete
              :items="computedAvailableUsers"
              :label="$t('deputyAuth.form.fields.permittedUser.name') + '*'"
              :rules="validators.user_id"
              v-model="contextDeputyAuth.user_id"
            >
            </v-autocomplete>

            <date-time-picker-computed
              :date-time-model.sync="contextDeputyAuth.from_date"
              :label="$t('userSubstitute.userReplacementForm.fields.fromTime.name')"
              :placeholder="$t('userSubstitute.userReplacementForm.fields.fromTime.placeholder')"
            ></date-time-picker-computed>

            <date-time-picker-computed
              :date-time-model.sync="contextDeputyAuth.to_date"
              :label="$t('userSubstitute.userReplacementForm.fields.toTime.name')"
              :placeholder="$t('userSubstitute.userReplacementForm.fields.toTime.placeholder')"
            ></date-time-picker-computed>

            <v-text-field :label="$t('global.comment')" v-model="contextDeputyAuth.comment"></v-text-field>
            <v-autocomplete
              :label="$t('deputyAuth.form.fields.authItem.name') + '*'"
              :items="computedAvailableItems"
              :rules="validators.item_name"
              v-model="contextDeputyAuth.item_name"
            >
            </v-autocomplete>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="dialog = false" color="blue darken-1" text>{{ $t("global.cancel") }}</v-btn>
          <v-btn :disabled="!formValid || $store.getters['Ajax/loading']" @click="save" color="blue darken-1" text>{{ $t("global.save") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import DateTimePickerComputed from "../CustomInputComponents/DateTimePickerComputed.vue";

export default {
  name: "DeputyAuthEdit",
  components: { DateTimePickerComputed },
  props: {
    userSubstitute: {
      required: false,
      default: () => ({
        id: null,
        item_name: null,
        user_id: null,
        from_date: null,
        to_date: null,
        comment: null
      })
    }
  },
  data: () => {
    return {
      contextDeputyAuth: null,
      dialog: false,
      formValid: true,
      availableUsers: [],
      availableItems: []
    };
  },
  computed: {
    validators() {
      return {
        user_id: [this.contextDeputyAuth.user_id != null || this.$t("global.error.required")],
        from_date: [
          //v => (v != null && v.length > 0) || 'Nazwa jest wymagana' //TODO WALIDATOR data nie moze byc pozniejsza niz data koncowa
        ],
        to_date: [
          //v => (v != null && v.length > 0) || 'Nazwa jest wymagana' //todo walidator data nie moze byc wcześniejsza niż data początkowa
        ],
        item_name: [this.contextDeputyAuth.item_name != null || this.$t("global.error.required")]
      };
    },
    computedAvailableUsers() {
      let result = [];
      for (let user of this.availableUsers) {
        if (user.id !== this.$store.state.Auth.userProperties.user_id) result.push({ value: user.id, text: user.name + " " + user.surname });
      }
      return result;
    },
    computedAvailableItems() {
      let result = [];
      for (let item of this.availableItems) {
        result.push({
          value: item.item_name,
          text: item.item_name + "=>" + item.description
        });
      }
      return result;
    }
  },
  beforeMount() {
    this.contextDeputyAuth = this.userSubstitute;
  },
  created() {
    this.axios.get("settings/admin-deputy-auth/available-users").then(resp => {
      this.availableUsers = resp.data;
    });
    this.axios.get("settings/admin-deputy-auth/available-items").then(resp => {
      this.availableItems = resp.data;
    });
  },
  methods: {
    save() {
      if (this.$refs.form.validate()) {
        this.axios
          .post("settings/admin-deputy-auth/add-deputy-auth", this.contextDeputyAuth)
          .then(() => {
            if (this.userSubstitute.id == null) {
              this.contextDeputyAuth.user_id = null;
              this.contextDeputyAuth.from_date = null;
              this.contextDeputyAuth.to_date = null;
              this.contextDeputyAuth.comment = null;
              this.contextDeputyAuth.item_name = null;
            }
            this.$store.dispatch("AUTH_UPDATE_SETTINGS").then(() => {
              this.$store.dispatch("snackbarPush", {
                text: this.$t("global.saved")
              });
              this.$emit("saved");
              this.dialog = false;
            });
          })
          .catch(resp => {
            console.log(resp.response);
          });
      }
    }
  }
};
</script>

<style scoped></style>
